import { FunctionalInterfaceParams } from "@/types/functionalInterfaceTypes";

export class FunctionalInterface {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  propelOrgId: string;
  name: string;
  description: string;

  constructor(params: FunctionalInterfaceParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.propelOrgId = params.propelOrgId;
    this.name = params.name || '';
    this.description = params.description || '';
  }
}
